import type React from 'react';

import { Separator, Text } from '@change/ds-core-ui';

import { useTopIssues } from './hooks/useTopIssues';

export const TopIssues: React.FC<EmptyProps> = () => {
	const {
		data: { issues },
	} = useTopIssues();

	if (issues.length === 0) return null;

	return <TopIssuesContent />;
};

const TopIssuesContent: React.FC<EmptyProps> = () => {
	const {
		data: { headingText, issues },
	} = useTopIssues();

	return (
		<>
			<Separator orientation="horizontal" className="mb-14" />
			<div className="flex flex-col gap-5 pb-8 md:gap-8" data-testid="dm-top-issues-container">
				<Text as="h2" variant="heading" size="small">
					{headingText}
				</Text>

				<ul className="flex flex-col gap-5 md:gap-6">
					{issues.map((issue) => (
						<li className="flex flex-col gap-2" key={`Issue_${issue.issueId}`}>
							<Text fontWeight="bold">
								{issue.graphic} {issue.title}
							</Text>

							<ul className="ml-5.5 flex list-outside list-disc flex-col">
								{issue.stances.map((stance) => (
									<li key={`Issue_${issue.issueId}_Stance_${stance}`} className="text-typography-strong">
										<Text size="small" className="text-typography-strong">
											{stance}
										</Text>
									</li>
								))}
							</ul>
						</li>
					))}
				</ul>
			</div>
		</>
	);
};
